import ReactDOM from 'react-dom/client'
import { APIProvider } from '@vis.gl/react-google-maps'
import { ThemeProvider } from '@mui/material'
import { QueryClientProvider } from '@tanstack/react-query'

import { queryClient } from '@/config/react-query'
import { ToastProvider } from '@/contexts/ToastContext'
import { AuthProvider } from '@/contexts/AuthContext'

import reportWebVitals from './reportWebVitals'
import { OTAUpdater } from './lib/ota-updater'
import { Logger } from './lib/logger'

import App from './App'
import theme from './theme'

const logger = new Logger('Root')
logger.info('Application started')
logger.info(`Running in ${process.env.NODE_ENV} mode`)

const otaUpdater = new OTAUpdater()

otaUpdater.notifyAppReady()
otaUpdater.checkUpdate()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ThemeProvider theme={theme}>
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </APIProvider>
  </ThemeProvider>
)

reportWebVitals()
